import Vue from 'vue'
import {clonePart} from '@/utils/useStylesheet'

const state = () => ({
  favorites: null,
  categories: []
})

const getters = {}

const actions = {
  async addToGlobal ({rootState}, {favorite, inGlobal}) {
    const unset = inGlobal ? {unset: true} : null
    return await axios.put(`api/projects/${rootState.projects.project.id}/favorite-blocks/global/${favorite.id}`, unset)
  },

  async addFavorite ({dispatch, rootState}, {favorite, inGlobal, inSharable, origSection, node}) {
    VEvent.fire('alt-loader', {
      state: true,
      message: 'Saving...'
    })

    const fonts = await dispatch('font/prepareFonts', {}, {root: true})

    const content = inSharable ? clonePart({
      ...favorite,
      fonts: fonts.googleFonts + fonts.customFonts,
      isGlobal: !!(origSection && inGlobal || origSection && inSharable),
      isSharable: !!(origSection && inGlobal || origSection && inSharable)
    }, node) : clonePart({
      ...favorite,
      fonts: fonts.googleFonts + fonts.customFonts,
      isGlobal: !!(origSection && inGlobal || origSection && inSharable),
      isSharable: !!(origSection && inGlobal || origSection && inSharable)
    }, node).replace(/"id":\d+,?/g, '')
      .replace(/"form_id":\d+,?/g, '')
      .replace(/,\}/g, '}')

    // const isSharable = origSection ? origSection.isSharable : false

    await dispatch('fetchFavorites')

    let isActiveFavorite = null
    if (origSection?.favId) {
      isActiveFavorite = rootState.favorites.favorites.find(fav => fav.project_id === rootState.projects.project.id && fav.id === origSection.favId)
    }

    if (isActiveFavorite) {
      await axios.put(`api/projects/${rootState.projects.project.id}/favorite-blocks/${origSection.favId}?set_global=${inGlobal}`, {
        block: content,
        sharable: content.isSharable
      })
        .then(async () => {
          // const {data: block} = await axios.get(`api/projects/${rootState.projects.project.id}/favorite-blocks/${origSection.favId}`)
          // await axios.get(`https://${this.project.subdomain}.estage.site/api/internal-embed/clean?code=${block.data.hash}`)

          await dispatch('fetchFavorites')

          VEvent.fire('alt-loader', {
            state: false,
            message: 'Synced!'
          })
        })
    } else {
      await axios.post(`api/projects/${rootState.projects.project.id}/favorite-blocks?set_global=${inGlobal}`, {
        block: content,
        sharable: true
      })
        .then(async ({data}) => {
          dispatch('fetchFavorites')

          if (origSection && inGlobal || origSection && inSharable) {
            Vue.set(origSection, 'name', favorite.section.name)
            Vue.set(origSection, 'isGlobal', true)
            Vue.set(origSection, 'isSharable', true)
            Vue.set(origSection, 'favId', data.data.id)
          }

          await dispatch('projects/save', {}, {root: true})

          VEvent.fire('alt-loader', {
            state: false,
            message: 'Added to favorites.'
          })
        })
    }
  },
  async removeFavorite ({state, rootState}, payload) {
    VEvent.fire('alt-loader', {
      state: true,
      message: 'Removing...'
    })

    await axios.delete(`api/projects/${rootState.projects.project.id}/favorite-blocks/${payload.favorite.id}`)
      .then(() => {
        state.favorites.splice(payload.index, 1)
        VEvent.fire('alt-loader', {
          state: false,
          message: 'Removed from favorites.'
        })
      })
  },
  async fetchFavorites ({state, rootState}, hideBlocks = false) {
    await axios.get(`api/projects/${rootState.projects.project.id}/favorite-blocks?perPage=250`)
      .then(({data}) => {
        state.favorites = data.data.data
          .map(({id, block, user_id, project_id, hash, category, category_id}) => {
            return {
              id,
              block: JSON.parse(block),
              user_id,
              project_id,
              hash,
              category,
              category_id
            }
          })
          .filter(item => hideBlocks ? item.block.group !== 'blocks' : true)
      })
  },
  async fetchFavoritesCategories ({state, rootState}) {
    await axios.get(`api/projects/${rootState.projects.project.id}/favorite-blocks/categories?perPage=100`)
      .then(({data}) => {
        state.categories = data.data
      })
  },
  setCategories ({state}, payload) {
    const ids = state.categories.map(item => item.id)
    const newCategories = payload.filter(item => !ids.includes(item.id))
    state.categories = [...state.categories, ...newCategories]
  },
  showNotPaidToast () {
    this.$swal.fire({
      icon: 'warning',
      title: 'Restricted Access!',
      text: 'This page contains licensed content (inside internal embed code) that is currently being used on another project/hub. Based on your license, you can only use this content on one hub.',
      showConfirmButton: false
    })
  },
  async usePaidBlock ({rootState}, payload) {
    const { data } = await axios.get(
      `api/projects/${rootState.projects.project.id}/favorite-blocks/use-paid-block/${payload.hash}`
    )
    return data.data
  },
  async checkPaidBlock ({rootState, dispatch}, payload) {
    const { data: access } = await axios.get(
      `api/projects/${rootState.projects.project.id}/favorite-blocks/check-paid-block/${payload.hash}`
    )
    if (!access?.data) {
      return {
        status: false,
        is_paid: false
      }
    }

    const { data: block } = await axios.get(
      `api/projects/favorite-blocks/${payload.hash}`
    )

    if (block.data?.is_paid) {
      const paidBlock = await dispatch('usePaidBlock', {hash: payload.hash})
      if (!paidBlock) return {
        status: false,
        is_paid: block.data?.is_paid
      }
    }

    return {
      status: true,
      is_paid: block.data?.is_paid
    }
  }
}

const mutations = {}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
